import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit
} from '@angular/core';
import { LgvPricingService } from '../../../features/pricing/services/pricing.service';
import { LoanAppPageService } from '../../../core/services/page-services/loan-app-page.service';
import {
    BehaviorSubject,
    first,
    map,
    mergeMap,
    of,
    Subject,
    takeUntil,
    withLatestFrom,
    zip
} from 'rxjs';
import { LgvPricingModel } from '../../../features/pricing/models/pricing.model';
import { LgvClientService, LgvUserService } from '../../../core/core.module';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'lgv-loan-app-quotes',
    templateUrl: './loan-app-quotes.component.html',
    styleUrls: ['./loan-app-quotes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppQuotesComponent implements OnInit, OnDestroy {
    onDestroy$ = new Subject();
    pricingScenariosForLoan$ = new BehaviorSubject<
        LgvPricingModel.PricingScenario[]
    >(null);
    currentPreApprovedPricing$ = new BehaviorSubject<
        LgvPricingModel.PricingScenario
    >(null);
    clientId = '';
    loanApplication: any;
    viewArchivedLoansCtrl = new FormControl(false);
    currentDate = new Date();

    constructor(
        private lgvPricingSvc: LgvPricingService,
        public loanAppPageSvc: LoanAppPageService,
        private lgvClientSvc: LgvClientService,
        public lgvUserSvc: LgvUserService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.lgvClientSvc.loadScenarios();

        this.lgvClientSvc.pricingScenarios$
            .pipe(
                withLatestFrom(this.loanAppPageSvc.selectedLoanApplication$),
                map(([scenarios, loanApp]) => {
                    this.loanApplication = loanApp;
                    this.clientId = loanApp?.loanInfo?.borrowers[0]?.clientId;

                    return scenarios?.filter(
                        s => s?.loanApplicationId == loanApp.id
                    );
                }),
                takeUntil(this.onDestroy$)
            )
            .subscribe(scenarios => {
                // remove deal desk pre-approved
                const filteredScenarios = scenarios.filter(
                    s =>
                        !this.lgvPricingSvc.checkIfDealDeskPreApprovedPricing(s)
                );
                this.pricingScenariosForLoan$.next(filteredScenarios);
                const currentPreApprovedPricing = this.lgvPricingSvc.getDealDeskPreApprovedPricing(
                    scenarios
                );
                this.currentPreApprovedPricing$.next(currentPreApprovedPricing);
            });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    goToPricingPage(i) {
        let baseUrl;
        if (!this.currentPreApprovedPricing$?.value) {
            baseUrl = `/admin/pricing-scenario/client/${this.clientId}/loanApp/${this.loanApplication.id}`;
        } else {
            baseUrl = `/admin/pricing-scenario/client/${this.clientId}/scenario/${this.currentPreApprovedPricing$?.value?.id}/loanApp/${this.loanAppPageSvc.selectedLoanApplication$.value?.id}`;
        }

        this.router.navigate([baseUrl], {
            queryParams: {
                from: 'loan-app-quotes'
            }
        });
    }

    goToVault() {
        this.router.navigate([
            `/admin/loan-app/${this.loanAppPageSvc.selectedLoanApplication$?.value?.id}/vault`
        ]);
    }
}
